/** Build an sms: deeplink — opens the admin device's Messages app with the
 * guest's number and a pre-filled text. Works on iOS and Android (?&body=
 * hybrid). Returns "" when there's no usable phone number. */
export const smsHref = (phone, message) => {
  const digits = String(phone || "").replace(/[^\d+]/g, "");
  if (!digits) return "";
  return `sms:${digits}?&body=${encodeURIComponent(message)}`;
};

export const firstName = (name) => (name || "there").split(" ")[0];
